import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0e053a62"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { class: "mod_wrap" }
const _hoisted_4 = { class: "mod_c" }
const _hoisted_5 = { class: "mod_c_title" }
const _hoisted_6 = { class: "pleft_btn" }
const _hoisted_7 = { class: "mod_nav_btn_title" }
const _hoisted_8 = { class: "mod_c_tbody select_none" }

import { computed, ref } from 'vue';
import { useRoute } from 'vue-router';
import Crumb from '@/components/Crumb.vue';

const __default__ = { name: '' };

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const route = useRoute();
const ViewVisable = computed(() => route.name === 'LiveList' || route.name === 'LiveType');
// 切换视图按钮
const cutoverView = ref(true);
const getCutoverIcon = computed(() => {
  return cutoverView.value ? 'list' : 'block';
});
const getCutoverName = computed(() => {
  return cutoverView.value ? '列表视图' : '缩略视图';
});
const switchView = () => {
  cutoverView.value = !cutoverView.value;
};

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_svg_icon = _resolveComponent("svg-icon")!
  const _component_a_button = _resolveComponent("a-button")!

  return (_unref(route).meta?.customMode)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_router_view)
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_2, [
        _createVNode(Crumb),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createTextVNode(_toDisplayString(_unref(route).meta?.title) + " ", 1),
              _createElementVNode("div", _hoisted_6, [
                (_unref(ViewVisable))
                  ? (_openBlock(), _createBlock(_component_a_button, {
                      key: 0,
                      type: "link",
                      class: "mod_btn_primary switch_btn actived crumb",
                      onClick: switchView
                    }, {
                      icon: _withCtx(() => [
                        _createVNode(_component_svg_icon, {
                          class: "btn_icon",
                          "icon-class": _unref(getCutoverIcon)
                        }, null, 8, ["icon-class"])
                      ]),
                      default: _withCtx(() => [
                        _createElementVNode("span", _hoisted_7, _toDisplayString(_unref(getCutoverName)), 1)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_router_view, { "view-switch": cutoverView.value }, null, 8, ["view-switch"])
            ])
          ])
        ])
      ]))
}
}

})